export enum Steps {
  S1Location,
  S2HealthCare,
  S3TimeAvailable,
  S4ConfirmationScreen,
}
